import { useEffect, useRef } from 'react';
import { JsFuncs } from '../../../../foundation/js/js.funcs';
import { StackX } from '../../../../foundation/layout/stack-x';
import { NodeDoneService } from '../../../core/node/node-done.service';
import { NodeDoneStore } from '../../../core/node/node-done.store';
import { AuthStateContext } from '../../../core/user/auth.context';
import { TodayDoneStyle } from './today-done.style';

export function TodayDone() {
  const authState = AuthStateContext.use();
  const { todayCount } = NodeDoneStore.use();

  const prevCountRef = useRef(todayCount ?? 0);

  useEffect(() => {
    (async () => {
      if (!authState.state.isAuthenticated) {
        return;
      }

      if (JsFuncs.isNotNull(NodeDoneStore.get().todayCount)) {
        return;
      }

      await NodeDoneService.fetchTodayCount();
    })();
  }, [authState.state.isAuthenticated]);

  useEffect(() => {
    prevCountRef.current = todayCount ?? 0;
  }, [todayCount]);

  if (!authState.state.isAuthenticated) {
    return null;
  }

  const isIncreased = (todayCount ?? 0) > prevCountRef.current;

  // return <></>;

  return (
    <TodayDoneStyle.Container>
      <StackX $gap="5px" $align="baseline">
        <TodayDoneStyle.NumberText key={todayCount} $animate={isIncreased}>
          {todayCount ?? 0}
        </TodayDoneStyle.NumberText>
        <TodayDoneStyle.Text>Done in today</TodayDoneStyle.Text>
      </StackX>
    </TodayDoneStyle.Container>
  );
}
